export enum ComponentMapIds {
    CustSearch = 'CustSearch',
    VehSel = 'VehSel',
    SignUp = 'SignUp',
    MaintenanceMenus = 'MaintenanceMenus',
    AdditionalServices = 'AdditionalServices',
    Login = 'Login',
    CurrentRepair = 'CurrentRepair',
    ViewAppt = 'ViewAppt',
    AddAppt = 'AddAppt',
    ViewAccount = 'ViewAccount',
    ServiceDocs = 'ServiceDocs',
    DocumentViewer = 'DocumentViewer',
    ChangePassword = 'ChangePassword',
    Vehicle = 'Vehicle',
    Recalls = 'Recalls',
    RecommendedServices = 'RecommendedServices',
    RepairHistory = 'RepairHistory',
    AddVehicle = 'AddVehicle',
    ContactDealer = 'ContactDealer',
    UserAccountMenu = 'UserAccountMenu',
    ServiceTab = 'ServiceTab',
    AddSkipServices = 'AddSkipServices',
    QuickTime = 'QuickTime',
    CalendarSelect = 'CalendarSelect',
    NewCustInfo = 'NewCustInfo',
    Summary = 'Summary',
    Confirmation = 'Confirmation',
    ResetPassword = 'ResetPassword',
    PropertyOptions = 'PropertyOptions',
    AddCustVehicle = 'AddCustVehicle',
    VehLayout = 'VehLayout',
    ApptSel = 'ApptSel',
    OpenRepairSelect = 'OpenRepairSelect',
    ThankYou = 'ThankYou',
    LandingPage = 'LandingPage',
    ViewServiceHistory = 'ViewServiceHistory',
    UpdateMileage = 'UpdateMileage',
    DiagnoseTree = 'DiagnoseTree',
    DiagnoseEnd = 'DiagnoseEnd',
    VerifyIdentity = 'VerifyIdentity',
    OEMCustSearch = 'OEMCustSearch',
    PickupDelivery = 'PickupDelivery',
}

export interface IRelatedComponent {
    component: ComponentMapIds;
    requireOpenedPanel: boolean;
}